var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { Box, Button, CircularProgress, IconButton, Typography, } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { ChartRenderer } from "../../shared/charts";
var normalizeFileName = function (title) {
    return title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .slice(0, 50) || "grafico";
};
function exportChartAsPdf(node, title) {
    return __awaiter(this, void 0, void 0, function () {
        var bounds, captureWidth, captureHeight, canvas, now, pad, fileName, isLandscape, pageWidth, pageHeight, pdf;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bounds = node.getBoundingClientRect();
                    captureWidth = Math.ceil(Math.max(node.scrollWidth, bounds.width));
                    captureHeight = Math.ceil(Math.max(node.scrollHeight, node.offsetHeight, bounds.height));
                    return [4 /*yield*/, html2canvas(node, {
                            scale: 2,
                            backgroundColor: "#FFFFFF",
                            useCORS: true,
                            width: captureWidth,
                            height: captureHeight,
                            windowWidth: captureWidth,
                            windowHeight: captureHeight,
                            scrollX: 0,
                            scrollY: 0,
                        })];
                case 1:
                    canvas = _a.sent();
                    now = new Date();
                    pad = function (v) { return v.toString().padStart(2, "0"); };
                    fileName = "".concat(normalizeFileName(title), "-").concat(pad(now.getFullYear() % 100)).concat(pad(now.getDate())).concat(pad(now.getMonth() + 1)).concat(pad(now.getHours())).concat(pad(now.getMinutes())).concat(pad(now.getSeconds()), ".pdf");
                    isLandscape = canvas.width >= canvas.height;
                    pageWidth = isLandscape ? 842 : 595;
                    pageHeight = (canvas.height * pageWidth) / canvas.width;
                    pdf = new jsPDF({
                        orientation: isLandscape ? "landscape" : "portrait",
                        unit: "pt",
                        format: [pageWidth, pageHeight],
                    });
                    pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, pageWidth, pageHeight);
                    pdf.save(fileName);
                    return [2 /*return*/];
            }
        });
    });
}
export var getChartFamilyType = function (chartType) {
    return (chartType === null || chartType === void 0 ? void 0 : chartType.startsWith("bar")) ? "bar" : chartType;
};
export var isCompactChartFamily = function (chartFamilyType) {
    return chartFamilyType === "pie" || chartFamilyType === "table";
};
export var getChartGridMd = function (chartType, options) {
    var chartFamilyType = getChartFamilyType(chartType);
    if (options === null || options === void 0 ? void 0 : options.forceAllFullWidth) {
        return 12;
    }
    return isCompactChartFamily(chartFamilyType) ? 6 : 12;
};
export var buildCompactRunWidths = function (count) {
    return Array.from({ length: count }, function () { return 6; });
};
export var buildCompactChartWidthOverrides = function (charts) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var overrides = {};
    var _loop_1 = function (index) {
        var family = getChartFamilyType((_b = (_a = charts[index]) === null || _a === void 0 ? void 0 : _a.chartType) !== null && _b !== void 0 ? _b : (_d = (_c = charts[index]) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.chart);
        if (!isCompactChartFamily(family)) {
            index += 1;
            return out_index_1 = index, "continue";
        }
        var runEnd = index;
        while (runEnd < charts.length &&
            isCompactChartFamily(getChartFamilyType((_f = (_e = charts[runEnd]) === null || _e === void 0 ? void 0 : _e.chartType) !== null && _f !== void 0 ? _f : (_h = (_g = charts[runEnd]) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.chart))) {
            runEnd += 1;
        }
        buildCompactRunWidths(runEnd - index).forEach(function (width, offset) {
            overrides[index + offset] = width;
        });
        index = runEnd;
        out_index_1 = index;
    };
    var out_index_1;
    for (var index = 0; index < charts.length;) {
        _loop_1(index);
        index = out_index_1;
    }
    return overrides;
};
export var buildChartGridMdMap = function (charts, options) {
    var _a, _b, _c, _d, _e;
    var gridMdMap = {};
    var lgbtqiaWidthOverrides = (_a = options === null || options === void 0 ? void 0 : options.lgbtqiaWidthOverrides) !== null && _a !== void 0 ? _a : {};
    for (var index = 0; index < charts.length;) {
        var chartType = (_c = (_b = charts[index]) === null || _b === void 0 ? void 0 : _b.chartType) !== null && _c !== void 0 ? _c : (_e = (_d = charts[index]) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.chart;
        var explicitWidth = lgbtqiaWidthOverrides[index];
        if (explicitWidth != null) {
            gridMdMap[index] = explicitWidth;
            index += 1;
            continue;
        }
        gridMdMap[index] = getChartGridMd(chartType, options);
        index += 1;
    }
    return gridMdMap;
};
export var ChartCard = function (_a) {
    var _b, _c;
    var chart = _a.chart, onDownloadToast = _a.onDownloadToast, onDelete = _a.onDelete, mobileLegendList = _a.mobileLegendList;
    var cardRef = useRef(null);
    var _d = useState(false), isExporting = _d[0], setIsExporting = _d[1];
    var handleDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!cardRef.current || isExporting)
                        return [2 /*return*/];
                    setIsExporting(true);
                    onDownloadToast();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, exportChartAsPdf(cardRef.current, chart.title)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsExporting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, __assign({ ref: cardRef, sx: {
            background: "#fff",
            borderRadius: "14px",
            border: "1px solid #ECEEF4",
            p: { xs: 2, sm: 2.5 },
            height: "auto",
            minWidth: 0,
            minHeight: 0,
            overflow: "visible",
            display: "flex",
            flexDirection: "column",
        } }, { children: [_jsxs(Box, __assign({ sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    mb: 1.5,
                    gap: 1,
                    flexDirection: { xs: "column", sm: "row" },
                } }, { children: [_jsxs(Box, __assign({ sx: { minWidth: 0, width: "100%" } }, { children: [_jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 700,
                                    fontSize: { xs: "1rem", sm: "0.9rem" },
                                    color: "#1F2937",
                                    lineHeight: 1.3,
                                } }, { children: chart.title })), chart.subtitle && (_jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: { xs: "0.82rem", sm: "0.75rem" },
                                    color: "#4B5563",
                                    mt: 0.3,
                                } }, { children: chart.subtitle })))] })), _jsxs(Box, __assign({ sx: {
                            display: "flex",
                            gap: 0.5,
                            flexShrink: 0,
                            width: { xs: "100%", sm: "auto" },
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                        } }, { children: [_jsx(Button, __assign({ size: "small", startIcon: isExporting ? (_jsx(CircularProgress, { size: 12, sx: { color: "#6B7280" } })) : (_jsx(DownloadIcon, { sx: { fontSize: "16px !important" } })), onClick: handleDownload, disabled: !chart.data || isExporting, variant: "outlined", sx: {
                                    textTransform: "none",
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 600,
                                    fontSize: "0.75rem",
                                    borderRadius: "8px",
                                    borderColor: "#E5E7EB",
                                    color: "#6B7280",
                                    px: 1.5,
                                    py: 0.5,
                                    minWidth: { xs: 112, sm: "auto" },
                                    "&:hover": { borderColor: "#034EA2", color: "#034EA2" },
                                } }, { children: "Baixar" })), onDelete && (_jsx(IconButton, __assign({ size: "small", onClick: onDelete, sx: {
                                    color: "#9CA3AF",
                                    "&:hover": {
                                        color: "#EF4444",
                                        background: "rgba(239,68,68,0.08)",
                                    },
                                    borderRadius: "8px",
                                    border: "1px solid #E5E7EB",
                                } }, { children: _jsx(DeleteIcon, { sx: { fontSize: 16 } }) })))] }))] })), chart.error ? (_jsx(Box, __assign({ sx: {
                    minHeight: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                } }, { children: _jsx(Typography, __assign({ sx: {
                        fontFamily: "Montserrat, sans-serif",
                        fontSize: "0.82rem",
                        color: "#4B5563",
                        textAlign: "center",
                    } }, { children: "Dados n\u00E3o dispon\u00EDveis para esta consulta." })) }))) : (_jsx(Box, __assign({ sx: { minWidth: 0, overflow: "visible" } }, { children: _jsx(ChartRenderer, { data: (_b = chart.data) !== null && _b !== void 0 ? _b : {
                        columns: [],
                        dataset: [],
                        chart: (_c = chart.chartType) !== null && _c !== void 0 ? _c : "bar",
                        aggregation: null,
                        filters: null,
                    }, bare: true, chartType: chart.chartType, mobileLegendList: mobileLegendList, loading: !chart.data }) })))] })));
};
